import * as React from "react";
import { Mutation, MutationFn } from "react-apollo";
import {
  DeleteMailingListMutation,
  DeleteMailingListMutationVariables
} from "../../__generated__/types";
import { DELETE_MAILINGLIST_QUERY } from "./queries";
import { ApolloError } from "apollo-client";
import { MAILING_LISTS_QUERY } from "src/queries/MailingListsQuery/queries";

class DeleteMailingListM extends Mutation<DeleteMailingListMutation> {}

export interface Props {
  onError?: (error: ApolloError) => void;
  onCompleted?: (data: DeleteMailingListMutation) => void;
  children(
    props: MutationFn<
      DeleteMailingListMutation,
      DeleteMailingListMutationVariables
    >
  ): JSX.Element | null;
}

export interface State {}

export default class DeleteMailingList extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {};
  }

  render() {
    return (
      <DeleteMailingListM
        mutation={DELETE_MAILINGLIST_QUERY}
        refetchQueries={[{ query: MAILING_LISTS_QUERY }]}
        awaitRefetchQueries={true}
        onError={this.props.onError}
        onCompleted={this.props.onCompleted}
      >
        {(mutation, result) => this.props.children(mutation)}
      </DeleteMailingListM>
    );
  }
}



// WEBPACK FOOTER //
// ./src/mutations/DeleteMailingList/DeleteMailingList.tsx